// extracted by mini-css-extract-plugin
export default {"message":"FeedItemList-message","loadmore":"FeedItemList-loadmore"};